let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      // One subscriber failing must not stop the rest, or the code that published
      // (e.g. the add to cart handler, which then never updates the drawer).
      try {
        callback(data);
      } catch (error) {
        console.error('Subscriber for "' + eventName + '" failed', error);
      }
    });
  }
}
